<template>
  <div id="app">
    <router-view
      @isFucountry="lisFucountry"
      :isdatacountry="datacountry"
      :iscountryname="countryname"
      @isSupplysearchkeyword="supplyserachkeyword"
      :issupplykyeWord="supplykyeWord"
      @ispurchasingFucountry="apurchasingFucountry"
      :isname="purchasingcountryname"
      :iscountry="purchasingdatacountry"
      @isskeyword="skeyword"
      :iskeywork="qiugoukeyword"
    />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      datacountry: "",
      countryname: "",
      supplykyeWord: "",
      aactivesearch: "",
      purchasingdatacountry: "",
      purchasingcountryname: "",
      qiugoukeyword: ""
    };
  },
  methods: {
    lisFucountry(data, name) {
      this.datacountry = data;
      this.countryname = name;
      this.$router.push("/searchsuppplyList");
    },
    supplyserachkeyword(n) {
      this.supplykyeWord = n;
    },
    apurchasingFucountry(data, name) {
      console.log("这是app里data:" + data);
      console.log("这是app里name:" + name);
      this.purchasingdatacountry = data;
      this.purchasingcountryname = name;
      this.$router.push("/searchpurchasingList");
    },
    skeyword(data) {
      this.qiugoukeyword = data;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue